import { ContentContainer, palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const StyledFooter = styled.div`
  border-top: ${palette.border.grey};
  padding: 36px 0;
  background-color: ${palette.colors.grey_base};
  ${ContentContainer} {
    padding: 0;
  }
`;

export const FooterInner = styled.div`
  display: flex;
  gap: 48px;
`;

export const FooterHeader = styled.div`
  display: flex;
  align-items: center;
  & svg {
    margin-right: 24px;
  }
`;

export const LinkGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & a:hover {
    color: ${palette.colors.green_base};
    transition: all ease-in 0.1s;
  }

  & {
    ${typography.body_large_medium};
  }
`;

export const FooterBody = styled.div`
  ${typography.body_medium_regular};
  color: ${palette.colors.secondary};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SocialContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  transition: all ease-in 0.1s;
  & > div {
    flex: 1 1 auto;
  }
  & a:hover {
    & {
      color: ${palette.colors.green_base};
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ColumnHeader = styled.div`
  ${typography.label_medium};
  color: ${palette.colors.secondary};
`;

export const ColumnItem = styled.div`
  ${typography.body_large_regular};
`;
